import * as React from 'react';

import {
  ContentCard,
  ContentEmpty,
  FontSemiBold,
  MeasuredValue,
  Money,
  TinyTable,
} from '@rematter/ui-web';
import { useAtomValue } from 'jotai';
import { LucideDot } from 'lucide-react';

import * as state from '../../_state/purchaseOrderDetails.state';

export const PurchaseOrderTabMaterials = () => {
  const {
    data: purchaseOrder,
    isLoading,
    error,
  } = useAtomValue(state.$purchaseOrderDetails);
  const hasMaterials = !!purchaseOrder?.lineItems?.length;
  const lineItems = React.useMemo(
    () => purchaseOrder?.lineItems ?? [],
    [purchaseOrder],
  );

  return (
    <div className="@PurchaseOrderTabMaterials h-full p-5">
      {!hasMaterials && (
        <ContentEmpty>This purchase order has no materials yet</ContentEmpty>
      )}
      {hasMaterials && (
        <ContentCard className="pt-5">
          <TinyTable
            isLoading={isLoading}
            error={error}
            data={lineItems}
            rowKey={(lineItem) => lineItem.id}
            columns={[
              {
                label: 'Material',
                key: 'material',
                cell: (lineItem) => lineItem.item?.name,
                footer: () => (
                  <FontSemiBold className="flex items-center gap-0.5">
                    Total
                    <LucideDot size={16} className="opacity-60" />
                    {lineItems.length} materials
                  </FontSemiBold>
                ),
              },
              {
                label: 'Net Weight',
                key: 'netWeight',
                align: 'right',
                cell: (lineItem) => <MeasuredValue {...lineItem.quantity} />,
                footer: () => (
                  <FontSemiBold>
                    <MeasuredValue {...purchaseOrder?.netWeight} />
                  </FontSemiBold>
                ),
              },
              {
                label: 'Unit Price',
                key: 'unitPrice',
                align: 'right',
                cell: (lineItem) => <Money {...lineItem.unitPrice} />,
              },
              {
                label: 'Total Price',
                key: 'totalPrice',
                align: 'right',
                cell: (lineItem) => <Money {...lineItem.totalPrice} />,
                footer: () => (
                  <FontSemiBold>
                    <Money {...purchaseOrder?.totalPrice} />
                  </FontSemiBold>
                ),
              },
            ]}
          />
        </ContentCard>
      )}
    </div>
  );
};
